<template>
  <!-- whole card is draggable -->
  <div class="candidate-card">
    <!-- S: name (always shown); clicking it opens the candidate detail page -->
    <router-link
      :to="{ name: 'candidate.detail', params: { id: candidate.candidate_entity_id } }"
      class="candidate-name text-truncate">
      {{ displayName }}
    </router-link>

    <!-- M: email / phone -->
    <template v-if="density === 'M'">
      <div v-if="candidate.email" class="candidate-line text-truncate">
        <IconMail :size="14" class="candidate-icon" />
        <span class="text-truncate">{{ candidate.email }}</span>
      </div>
      <div v-if="candidate.phone" class="candidate-line text-truncate">
        <IconPhone :size="14" class="candidate-icon" />
        <span class="text-truncate">{{ candidate.phone }}</span>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import type { CardDensity, KanbanCandidate } from '@/types/kanban';
import { computed } from 'vue';
import { IconMail, IconPhone } from '@tabler/icons-vue';
import translator from '@/locale/translator';

const props = defineProps<{
  candidate: KanbanCandidate;
  density: CardDensity;
}>();

const displayName = computed(() => {
  const name = [props.candidate.firstname, props.candidate.lastname].filter(Boolean).join(' ').trim();
  return name || translator.get('orders.details.kanban.unnamed_candidate');
});
</script>
<style scoped>
.candidate-card {
  display: flex;
  flex-direction: column;
  gap: 3px;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  cursor: grab;
  user-select: none;
}

.candidate-card:active {
  cursor: grabbing;
}

/* `.card-selected` is toggled by the MultiDrag plugin (not Vue), so it survives re-renders */
.candidate-card.card-selected {
  border-color: #1570ef;
  box-shadow: 0 0 0 1px #1570ef;
  background: #eff8ff;
}

.candidate-name {
  display: block;
  font-weight: 600;
  color: #101828;
  min-width: 0;
  text-decoration: none;
  cursor: pointer;
  width: fit-content;
}

.candidate-name:hover {
  color: #1570ef;
  text-decoration: underline;
}

.candidate-line {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #475467;
}

.candidate-icon {
  flex: 0 0 auto;
  color: #98a2b3;
}
</style>
